import React from 'react';

const ConfirmationPopup = ({ isOpen, onClose, onConfirm, title, message,color }) => {
  return (
    <>
      {isOpen && (
        <div className="modal is-active">
          <div className="modal-background" onClick={onClose}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title" style={{color:color}}>{title}</p>
              <button className="delete" aria-label="close" onClick={onClose}></button>
            </header>
            <section className="modal-card-body">
              {message}
            </section>
            <footer className="modal-card-foot">                
              <button className="button is-danger" style={{marginLeft:'470px'}} onClick={onConfirm}>Yes</button>
              <button className="button is-success" onClick={onClose}>No</button>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmationPopup;
